import { Component, OnInit, Input, Output, EventEmitter, OnChanges, ViewChild, ElementRef, AfterViewChecked } from '@angular/core';
import { PipeTransform, Pipe } from '@angular/core';
import { CommonService } from '../services/common.service';
import { WaitpromiseService } from '../services/waitpromise.service';
import { BehaviorSubject } from 'rxjs';
import { BsDropdownDirective } from 'ngx-bootstrap/dropdown';

declare var jquery: any;
declare var $: any;

@Pipe({ name: 'highlight' })
export class HighlightPipe implements PipeTransform {

  removeDiacritics = str => {
    return str
      .normalize('NFD')
      .replace(/[\u0300-\u036f]/g, '')
  }

  // Determines if a haystack contains a needle.  Case and accent insensitive.
  // Example: normalizedContains('Le Samouraï', 'I') -> true
  normalizedContains = (haystack, needle) => {
    const regExp = new RegExp(this.removeDiacritics(needle), 'gi');
    return regExp.test(this.removeDiacritics(haystack));
  }

  // Returns all films matching the input string.  Case and accent insensitive.
  findMatchingFilms = (strToMatch, films) => {
    return films.filter(filmTitle => this.normalizedContains(filmTitle, strToMatch))
  }

  transform(text: string, search): string {
    if (search && text) {
      let pattern = typeof search === 'string' ? search.replace(/[\-\[\]\/\{\}\(\)\*\+\?\.\\\^\$\|]/g, '\\$&') : '';
      pattern = pattern.split(' ').filter((t) => {
        return t.length > 0;
      }).join('|');
      pattern = pattern.normalize('NFD').replace(/[\u0300-\u036f]/g, '')
      // const regExp = new RegExp(this.removeDiacritics(pattern), 'gi');
      const regex = new RegExp(pattern, 'gi');

      const textString = ('' + (text || '')).normalize('NFD').replace(/[\u0300-\u036f]/g, '');
      // console.log(textString.split(pattern))
      return textString.replace(regex, (match) => `<span class="text-match">${match}</span>`);
    } else {
      return text;
    }
  }
}

@Component({
  selector: 'app-autocomplete',
  templateUrl: './autocomplete.component.html',
  styleUrls: ['./autocomplete.component.css']
})
export class AutocompleteComponent implements OnInit, OnChanges, AfterViewChecked {

  @Input() placeholder: String;
  @Input() dataSource: any[];
  @Input() results: any[];
  @Input() label: string;
  @Input() defaultsearch: String;
  @Input() id: String;
  @Input() notOblig: boolean;
  @Input() active: boolean;
  @Input() minlength: number;
  @Input() maxlength: number;
  @Input() autoshow: boolean;
  @Input() autohide: boolean;
  @Input() selectvalue: boolean;
  @Input() disablefocus: boolean;
  @Input() isCombo: boolean;
  @Input() container;
  @Input() model;
  @Input() items;
  @Input() defaultselected;
  @Input() dropdownclass: String;
  @Input() highlight: boolean;
  @Input() showonclick: boolean;
  @Input() showonFoscus: boolean;
  @Input() showResultKeyenter: boolean;
  @Input() deleteSelectedValue: boolean;
  @Input() isFixedHTML: boolean;
  @Input() rechercheIcone: boolean;
  @Input() htmlCode;
  @Input() notShowOnInit: Boolean = false;
  @Input() forceSelection: boolean;
  @Input() activeDropUp: boolean;
  @Input() activeVisibleChamp: boolean;
  @Input() visibleChamp: boolean;
  @Input() notLoading: boolean;
  @Input() isDisabled: Boolean = false;
  @Input() addTimerBlur: Boolean = false;
  @Input() deleteLibelle: Boolean = false;
  @Input() nePasCompterEspace: Boolean = false;
  @Input() encoursDechargement: Boolean = false;

  @Input() changeIDAutoComplete: Boolean = false;
  @Input() material: Boolean = false;
  @Input() positionDropdown = 'left';
  reload
  @Input() ActiveFocusCombo: Boolean = false;
  @Input() actualise: Boolean = false;
  @Input() isKeyUp: Boolean = false;
  @Input() isClearResult: Boolean = false;
  @Input() activeDelaiRecherche: Boolean = false;

  @Output() searchfunction = new EventEmitter<String>();

  @Output() selectfunction = new EventEmitter<String>();
  @Output() keyenterfunction = new EventEmitter<String>();
  @Output() focusfunction = new EventEmitter<any>();
  @Output() blurfunction = new EventEmitter<any>();
  @Output() clearfunction = new EventEmitter<any>();
  @Output() keyUp = new EventEmitter<any>();

  status: { isopen: boolean } = { isopen: false };
  plhd: String = '';
  isFocus: Boolean = false;
  search: String = '';
  isValueSel: Boolean = false;
  selected: any = {};
  delay;
  isChargement: boolean;
  dropup: Boolean = false;

  idElement = '';
  searchTest
  hasRequestLoad: Boolean = false;
  numeroAutoComplete: any = 0;
  doSomethingAfterSearch;
  searchExec: String = '';
  societe: any = {}

  @ViewChild('autocompletematerial') autocompletematerial: ElementRef;
  @ViewChild('dropdown') dropdown: BsDropdownDirective;
  constructor(protected common: CommonService, public waitProm: WaitpromiseService) {
    this.numeroAutoComplete = this.common.indexAutoComplete;
    this.common.indexAutoComplete++;
    // console.log('numero :', this.numeroAutoComplete)
    this.waitProm.doSomething[this.numeroAutoComplete] = new BehaviorSubject<any>(null)
    this.waitProm.doSomething[this.numeroAutoComplete].subscribe(data => {
      if (data) {
        this.hasRequestLoad = false;
        this.isChargement = false;
        this.encoursDechargement = false;
        this.doSomethingAfterSearch.next(this.searchExec)
        this.common.local.remove('numautocomplete');
        this.common.local.remove('IdRequeteEncours');
        // console.log('ato :', data)
      }
    })
    this.doSomethingAfterSearch = new BehaviorSubject<any>(null);
    this.doSomethingAfterSearch.subscribe(data => {
      // console.log(data, this.search)
      if (data && data !== this.search) {
        // console.log('recherche après : ', data, this.search)
        this.searchelement(this.search)
      } else {
        // console.log('Pas de recherche après')
      }
    });
  }

  showAutoCompleteMaterial() {
    this.autocompletematerial.nativeElement.focus();
  }

  ngOnInit() {
    // this.common.indexNameAutocomplete = this.common.indexNameAutocomplete + 1;

    this.search = this.defaultsearch || '';
    this.placeholder = this.placeholder || '';
    this.plhd = this.placeholder;
    this.selected = this.search.length ? (this.defaultselected ? this.defaultselected :
      (this.results && this.results.length ? this.results[0] : {})) : {};
    this.search = '' + this.search;
    this.minlength = this.minlength || 1;
    this.maxlength = this.maxlength || 524288;
    this.forceSelection = this.forceSelection || true;
    this.isChargement = this.notLoading ? false : true;
    const randomString = Math.random().toString(36).slice(-6);
    this.idElement = 'autocomplete' + randomString;
    const ctrl = this;
    const url = window.location.href || '';
    if (url.includes('ecofact')) {
      ctrl.changeIDAutoComplete = true;
    }

    if (!url.includes('/param/menu-article/article')) {
      if (!this.disablefocus && !this.selectvalue) {
        if (!this.common.isFiche) {
          const myVar = setTimeout(function () {
            if (ctrl.ActiveFocusCombo && ctrl.isCombo) {
              $('.' + ctrl.id).click();
            } else {
              $(ctrl.changeIDAutoComplete ? ('#' + ctrl.idElement) : '#autocomplete').focus();
            }
          }, 500);
        }
      }
    }
    this.selected = this.defaultselected ? this.defaultselected : this.selected;
    if (this.autoshow) {
      if (!this.status.isopen && !this.notShowOnInit) {
        this.toggleDropdown();
      }
      if (!this.hasRequestLoad) {
        this.hasRequestLoad = true
        this.common.local.set('numautocomplete', this.numeroAutoComplete)
        this.searchfunction.emit(this.search);
      }
    }

    if (this.isCombo) {
      if (!this.hasRequestLoad) {
        this.hasRequestLoad = true
        this.common.local.set('numautocomplete', this.numeroAutoComplete)
        this.searchfunction.emit(this.search);
      }
      this.selected = this.selected || (this.results && this.results.length ? this.results[0] : {});
    }
    // const box = $(this.autocompletematerial.nativeElement);
    // const width = box.offsetWidth;
    // console.log(width)
  }

  ngAfterViewChecked() {
    if (!this.isCombo) {
      this.common.dropdownObject[this.numeroAutoComplete] = this.dropdown;
    }

  }

  ngOnChanges(changes: any) {
    if (changes.defaultsearch) {
      this.search = '' + changes.defaultsearch.currentValue;
    }

    if (changes.encoursDechargement) {
      this.encoursDechargement = this.encoursDechargement || false;
    }

    if (changes.defaultselected) {
      this.selected = this.defaultselected ? this.defaultselected : this.selected;
      this.selected = this.selected || (this.results && this.results.length ? this.results[0] : {});
    }

    const IdRequeteEncours = Number(this.common.local.get('IdRequeteEncours'));
    if (!IdRequeteEncours || (IdRequeteEncours && IdRequeteEncours !== this.numeroAutoComplete)) {
      this.hasRequestLoad = false;
      this.isChargement = false;
      this.common.local.remove('numautocomplete');
      this.common.local.remove('IdRequeteEncours');
    }

    if (changes.results) {
      this.isChargement = false;
    }
  }

  closeDropDown() {
    // this.common.listDropDown.forEach(elt => {
    //   if (elt) {
    //     elt.ouvert = false;
    //     elt.hide();
    //   }
    // });
  }

  clickCombo() {
    this.focusfunction.emit();
  }

  focus(dropdown, event) {

    this.isFocus = true;
    this.focusfunction.emit();
    this.closeDropDown();

    if (event && event.target) {
      const offset = $(event.target).offset()
      const bottom = Math.abs($(window).height() - offset.top);
      this.dropup = bottom < 195 ? true : false;
    }

    // if (this.common.dropdown) {
    //   this.common.dropdown.hide();
    // }
    const ctrl = this;

    this.common.closeDropdown(this.numeroAutoComplete)
    setTimeout(function () {
      // ctrl.common.dropdown = dropdown;
      ctrl.focusfct();
    }, 50)

    // this.common.dropdown = dropdown;

  }

  focusfct() {
    if (this.autoshow) {
      if (this.common.dropdown) {
        this.common.dropdown['ouvert'] = true;
      }

      // this.common.listDropDown = [...this.common.dropdown];
    }
    if (this.selectvalue) {
      const focus = $(document.activeElement);
      this.isValueSel = true;
      focus.select();
    }

    if (this.showonclick) {
      setTimeout(() => {
        this.status.isopen = true;
        if (!this.hasRequestLoad) {
          this.hasRequestLoad = true
          this.isChargement = true;
          this.common.local.set('numautocomplete', this.numeroAutoComplete)

          this.searchfunction.emit(this.search);
        }

      }, 100);
    } else {
      if (this.showonFoscus) {
        if (!this.status.isopen) {
          this.toggleDropdown();
        }
        if (!this.hasRequestLoad) {
          this.hasRequestLoad = true
          this.isChargement = true;
          this.common.local.set('numautocomplete', this.numeroAutoComplete)
          this.searchfunction.emit('');
        }
      }
    }
  }

  blurfct() {
    if (!this.status.isopen) {
      const time = setTimeout(() => {
        clearTimeout(time);
        this.blurfunction.emit();
      }, this.addTimerBlur ? 50 : 0);
    }
  }

  searchelement(event) {
    const searchLength = this.nePasCompterEspace ? this.search.split(/\s+/).join('').length : this.search.length;
    this.societe = this.common.local.getObject('paramSociete') || {};
    if (this.isClearResult) {
      this.results = [];
      this.isChargement = true;
      this.encoursDechargement = true;
    }

    if (!searchLength || this.search === '' || this.isValueSel) {
      this.clearfunction.emit();
      this.isValueSel = false;
    }

    if (this.items && this.model) {
      this.items[this.model] = this.search;
    }

    if (searchLength >= this.minlength || this.autoshow) {
      const ctrl = this;
      ctrl.isChargement = true;
      if (!this.status.isopen) {
        this.toggleDropdown(event);
        if (this.common.dropdown) {
          this.common.dropdown['ouvert'] = true;
          // this.common.listDropDown = [...this.common.dropdown];
        }
      }

      let delairecherche = 500;
      clearTimeout(this.delay);
      if (ctrl.societe["clientCollectivite"] && ctrl.activeDelaiRecherche) {
        const userDetail = this.common.local.getObject('userDetail');
        delairecherche = userDetail['delaiRecherche'] || 500;
      }
      this.delay = setTimeout(() => {
        ctrl.results = [];
        if (!ctrl.hasRequestLoad) {
          ctrl.hasRequestLoad = true
          // ctrl.isChargement = true;
          ctrl.common.local.set('numautocomplete', ctrl.numeroAutoComplete);
          const searchLengthTime = this.nePasCompterEspace ? this.search.split(/\s+/).join('').length : this.search.length;
          if (searchLengthTime >= this.minlength || this.autoshow) {
            ctrl.searchExec = ctrl.search;
            ctrl.searchfunction.emit(ctrl.search);
          } else {
            ctrl.hasRequestLoad = false;
          }
        }
      }, delairecherche);
    }

    if (this.deleteSelectedValue && searchLength === 0) {
      this.selectfunction.emit();
    }
    if (searchLength < this.minlength && !this.autoshow) {
      this.status.isopen = false;
      this.results = [];
      if (this.common.dropdown) {
        this.common.dropdown['ouvert'] = false;
      }
      this.closeDropDown();
      this.results = [];
    }
  }

  toggleDropdown($event?: MouseEvent): void {
    this.status.isopen = !this.status.isopen;
  }

  change(value: boolean): void {
    this.status.isopen = value;
  }

  setFocusSelect(event?, dropdown?) {
    if (event) {
      console.log($(event.target).width())
    }
    if (event && event.target) {
      const offset = $(event.target).offset()
      const bottom = Math.abs($(window).height() - offset.top);
      this.dropup = bottom < 195 ? true : false;
    }

    if (this.showonclick) {
      if (!this.status.isopen) {
        this.toggleDropdown();
      }
      if (!this.hasRequestLoad) {
        this.hasRequestLoad = true
        this.isChargement = true;
        this.common.local.set('numautocomplete', this.numeroAutoComplete)
        this.searchfunction.emit(this.search);
      }
    }
    this.clickCombo();
    if (!this.showonclick && this.isCombo && !this.status.isopen) {
      this.status.isopen = true
    }
    this.selected = this.selected && this.selected['id'] ? this.selected : (this.results && this.results.length ? this.results[0] : {});
    setTimeout(() => {
      $('.selected').focus();
      this.common.closeDropdown()
    }, 500);
  }

  selectItem(item?) {
    const libelleCht = ((item.numChantier ? item.numChantier + ' / ' : '') + (item.responsable ? item.responsable + ' / ' : '')
      + item.ville + ' / ' + (item.telephone || ''))
    if (this.forceSelection) {
      this.selected = item;
      this.search = (item.libelleObjetEntite || libelleCht || '');
    } else {
      if (item) {
        if (this.selected.id !== item.id) {
          this.selected = item;
          this.search = this.autohide ? (item.libelleObjetEntite || libelleCht) : '';
        } else {
          this.selected = item;
          this.search = (item.libelleObjetEntite || libelleCht);
        }
      } else {
        this.selected = item || this.results[0];
        this.search = this.autohide ? (this.selected.libelleObjetEntite || libelleCht) : '';
      }
    }

    if (this.common.dropdown) {
      this.common.dropdown['ouvert'] = false;
    }

    this.status.isopen = !this.status.isopen;
    if (this.deleteLibelle) {
      this.search = '';
    }
    this.selectfunction.emit(this.selected);
    if (this.actualise) {
      setTimeout(() => {
        this.search = '' + this.defaultsearch;
        console.log('change', this.search)
      }, 300)
    }
  }

  valideChoice(item) {
    if (this.search === '' && this.showResultKeyenter) {
      if (!this.hasRequestLoad) {
        this.hasRequestLoad = true
        this.common.local.set('numautocomplete', this.numeroAutoComplete)
        this.searchfunction.emit(this.search);
      }
      if (!this.status.isopen) {
        this.toggleDropdown();
        if (this.common.dropdown) {
          this.common.dropdown['ouvert'] = true;
          this.closeDropDown();
        }
      }
    }
    if (this.results.length === 1) {
      this.selectItem(this.results[0]);
      console.log('this.results');
    }
    this.keyenterfunction.emit(item);
  }

  defaultFocus(event) {

    if (event) {
      // console.log($(event.target).width());
      if (!this.isKeyUp) {
        this.keyUp.emit(this.search);
      } else {
        this.keyUp.emit(event);
      }

    }

    if (!this.changeFocus) {
      if (this.status.isopen && (event.keyCode === 40) && event.target.nextElementSibling) {

        this.selected = this.results[0];
        // $('[tabindex=0]').focus();
        $('.selected').focus();
        setTimeout(function () {
          $('.selected').focus();
        }, 200);
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.status.isopen && (event.keyCode === 38) && event.target.previousElementSibling) {
        // $('[tabindex=0]').focus();
        this.selected = this.results[0];
        $('.selected').focus();
        setTimeout(function () {
          $('.selected').focus();
        }, 200);
        event.preventDefault();
        event.stopPropagation();
      }
    } else {
      if (this.status.isopen && (event.keyCode === 40)) {
        $('#dropdowauto').find('[tabindex=0]').focus();
        setTimeout(function () {
          $('.selected').focus();
        }, 200);
        this.selected = this.results[0];
        event.preventDefault();
        event.stopPropagation();
      }
      if (this.status.isopen && (event.keyCode === 38)) {
        $('#dropdowauto').find('[tabindex=0]').focus();
        setTimeout(function () {
          $('.selected').focus();
        }, 200);
        this.selected = this.results[0];
        event.preventDefault();
        event.stopPropagation();
      }
    }
  }

  changeFocus(event, i) {
    if (event.key) {
      const regexText = /^[\w.-]+$/;
      let existe = false;
      if (this.status.isopen && this.status.isopen && this.isCombo && event.key.match(regexText)) {
        this.results.forEach((item, i) => {
          const libelle = `${(item.libelleObjetEntite ? item.libelleObjetEntite : ((item.numChantier || '') + (item.responsable ? ' / ' : '') + (item.responsable || '') + (item.adresse1 ? ' / ' : '') +
            (item.adresse1 || '') + (item.ville ? ' / ' : '') + (item.ville || '') + (item.telephone ? ' / ' : '') + (item.telephone || '')))}`;
          if (!existe && (libelle.normalize('NFD').toLocaleLowerCase()).startsWith(event.key.toLocaleLowerCase())) {
            existe = true;
            this.selected = item;
            $('#dropdowauto').find('[tabindex=' + i + ']').each(function () {
              $(this).focus()
            });
          }
        })
      }
    }

    if ((event.keyCode === 40) && event.target.nextElementSibling) {
      event.target.nextElementSibling.focus();
      this.selected = this.results[i + 1];
    }
    if (this.status.isopen && (event.keyCode === 38) && event.target.previousElementSibling) {
      this.selected = this.results[i - 1];
      event.target.previousElementSibling.focus();
    }
  }

  // clickOutside($event) {
  //   const container = $('dropdown-menu');
  //   const event = $($event)[0];

  //   const isInput = event && event.id === ('autocomplete') ? true : false;
  //   console.log(isInput, !container.has(event).length)
  //   if (!isInput && !container.has(event).length) {
  //    if (this.common.dropdown) {
  //     this.common.dropdown['ouvert'] = false;
  //     //  this.common.dropdown.close();
  //    }
  //   }
  // }

  getPosition(event) {
    const bottom = Math.abs($(window).height() - event.clientY);
    this.dropup = bottom < 195
      // && this.activeDropUp 
      ? true : false;
  }


  searchfunctionEvent($event) {
    this.searchfunction.emit($event)
  }
  selectfunctionEvent($event) {
    this.selectfunction.emit($event);
  }
  keyenterfunctionEvent($event) {
    console.log('keyenterfunction')
    this.keyenterfunction.emit($event)
  }

  focusfunctionEvent($event) {
    this.focusfunction.emit($event)
  }
  blurfunctionEvent($event) {
    this.blurfunction.emit($event)
  }
  clearfunctionEvent($event) {
    this.clearfunction.emit($event)
  }

  keyUpEvent($event) {
    this.keyUp.emit($event)
  }

}
